import { object, string } from 'yup';

import { getMaxLengthErrMsg, validationErrMessages } from '@constants/validationConstants';
import { MAX_250_LENGTH } from '@constants/validationMessages';

export const schema = object({
	message: string()
		.trim()
		.max(MAX_250_LENGTH, getMaxLengthErrMsg('Location Description', MAX_250_LENGTH))
		.required(validationErrMessages?.message),
});
